import axios from "axios";
import { clearAuthSession } from "./clearAuthSession";

// 20s upper bound. Long enough for slow KSA mobile and bid-flow round trips,
// short enough that a stalled request reaches the page-level error UI in
// reasonable time instead of spinning forever.
const REQUEST_TIMEOUT_MS = 20000;

// Tag the error so callers (react-query, page-level error UIs) can decide
// whether to retry, show a typed message, or escalate. Pages that don't yet
// branch on `error.kind` keep working — the field is purely additive.
const tagErrorKind = (error) => {
  if (error.code === "ECONNABORTED" || /timeout/i.test(error.message || "")) {
    error.kind = "timeout";
  } else if (!error.response) {
    error.kind = "network";
  } else if (error.response.status === 401) {
    error.kind = "auth";
  } else if (error.response.status >= 500) {
    error.kind = "server";
  } else {
    error.kind = "client";
  }
  return error;
};

const errorCallBack = async (error) => {
  tagErrorKind(error);

  if (error.kind !== "auth" && error.kind !== "client") {
    console.error("[axios] " + error.kind + ":", error?.message, error?.config?.url);
  }

  if (error.kind === "auth") {
    clearAuthSession();
    window.location.href = "/";
  }
  return Promise.reject(error);
};

axios.defaults.timeout = REQUEST_TIMEOUT_MS;
axios.defaults.headers.common["x-auth-token-user"] =
  localStorage.getItem("token-off");
axios.defaults.headers.common["x-auth-lang"] =
  localStorage.getItem("language") || "English";

axios.interceptors.request.use(async (req) => {
  req.headers["x-auth-token-user"] = await localStorage.getItem("token-off");
  req.headers["x-auth-lang"] = localStorage.getItem("language") || "English";
  if (req.timeout == null || req.timeout === 0) {
    req.timeout = REQUEST_TIMEOUT_MS;
  }
  return req;
});

axios.interceptors.response.use((response) => response, errorCallBack);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
